<div *ngIf="profile" class="user-picture" data-testid="user-picture-container">
  <app-user-picture-preview
    [profile]="profile"
    [firstName]="firstName"
    [lastName]="lastName"
    [size]="avatarSize"
  ></app-user-picture-preview>

  <div class="user-picture__actions">
    <button
      *ngIf="profile[userMetadata]?.picture; else upload"
      type="button"
      class="btn btn-link p-0"
      (click)="deleteAvatar()"
      data-testid="user-picture-btn-delete"
    >Remove photo</button>

    <ng-template #upload>
      <dx-file-uploader
        id="user-pic-upload"
        [multiple]="false"
        [(value)]="userPicture"
        labelText=""
        accept="image/*"
        uploadMode="useForm"
        [showFileList]="false"
        [allowedFileExtensions]="['.jpg', '.jpeg', '.png']"
        selectButtonText="Upload photo"
        (onValueChanged)="onPictureChosen($event)"
        [elementAttr]="{ 'data-testid': 'user-picture-input-file' }"
      ></dx-file-uploader>
      <span class="allowed-extensions">.jpg or .png</span>
    </ng-template>
  </div>
</div>
